import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";

const useStyles = createUseStyles((theme) => ({
	row: {
		position: "relative",
		display: "flex",
		alignItems: "stretch",
		border: `1px solid ${theme.palette.colors.disabled}`,
		borderRadius: "10px 10px 0 0",
		"& > div": {
			borderRight: `solid 1px ${theme.palette.colors.disabled}`,
		},
		"& > div:last-child": {
			borderRight: 0,
		},
	},
	header: {
		padding: "13px 0",
		flexShrink: 0,
		backgroundColor: `${theme.palette.colors.whiteGray}`,
		textAlign: "center",
		textTransform: "uppercase",
		lineHeight: 1,
	},
	label: {
		color: `${theme.palette.colors.black}`,
		lineHeight: 0.71,
		letterSpacing: 2,
		fontSize: "12px",
		fontFamily: theme.fonts.medium,
	},
	aboutInfoHeader: {
		width: "335px",
		borderTopLeftRadius: "10px",
	},
	callsHeader: {
		width: "175px",
	},
	trafficHeader: {
		width: "175px",
	},
	costHeader: {
		width: "175px",
	},
	emptyHeader: {
		width: "262px",
		borderTopRightRadius: "10px",
	},
	[`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
		aboutInfoHeader: {
			width: "305px",
			borderTopLeftRadius: "10px",
		},
		callsHeader: {
			width: "135px",
		},
		trafficHeader: {
			width: "135px",
		},
		costHeader: {
			width: "135px",
		},
		emptyHeader: {
			width: "226px",
			borderTopRightRadius: "10px",
		},
	},
	[`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
		label: {
			fontSize: "10px",
		},
		aboutInfoHeader: {
			width: "200px",
			borderTopLeftRadius: "10px",
		},
		callsHeader: {
			width: "110px",
		},
		trafficHeader: {
			width: "110px",
		},
		costHeader: {
			width: "110px",
		},
		emptyHeader: {
			width: "176px",
			borderTopRightRadius: "10px",
		},
	},
}));

const TariffsHeader = ({ text }) => {
	const classes = useStyles();
	return (
		<div className={classes.row}>
			<div className={classNames(classes.header, classes.aboutInfoHeader)}>
				<span className={classes.label}>{text.ABOUT_TARIFF}</span>
			</div>
			<div className={classNames(classes.header, classes.callsHeader)}>
				<span className={classes.label}>{text.CALLS_AND_SMS}</span>
			</div>
			<div className={classNames(classes.header, classes.trafficHeader)}>
				<span className={classes.label}>{text.TRAFFIC}</span>
			</div>
			<div className={classNames(classes.header, classes.costHeader)}>
				<span className={classes.label}>{text.COST}</span>
			</div>
			<div className={classNames(classes.header, classes.emptyHeader)}>
				<span></span>
			</div>
		</div>
	);
};

export default TariffsHeader;
